import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postReviewEngine } from '../lib/review.api'
import type { ReviewAction } from '../types/review.types'
import { getGetAdminContentQueryKey } from '@/types/origin-point-engine'

export function useReviewAction() {
  const qc = useQueryClient()

  const mutation = useMutation({
    mutationFn: (input: {
      engineId: string
      action: ReviewAction
      note: string
    }) => postReviewEngine(input),

    onSuccess: async () => {
      await qc.invalidateQueries({
        queryKey: getGetAdminContentQueryKey(),
      })
    },
  })

  return {
    review: mutation.mutate,
    isPending: mutation.isPending, 
    error: mutation.error,
  }
}
